import { CommentWidget } from "./CommentWidget";
import { MultiChoiceWidget } from "./MultiChoiceWidget";
import { VideoWidget } from "./VideoWidget";
import { ImageWidget } from "./ImageWidget";
import { TriggerWidget } from "./TriggerWidget";
import { DownloadFileWidget } from "./DownloadFileWidget";
import { FillInTheBlankWidget } from "./FillInTheBlankWidget";
import { embedWidget, questionWidget } from "../../../constants/widget";

import "./index.css";

function TeacherReaderWidgets(props) {
  function isModuleImplemented(lessonModuleName) {
    return (
      lessonModuleName !== embedWidget &&
      lessonModuleName !== questionWidget
    );
  }

  function renderWidget(mod) {
    switch (mod.lesson_module_name) {
      case "LessonCommentModule":
        return <CommentWidget {...mod} />
      case "LessonMultipleChoiceQuestionModule":
        return <MultiChoiceWidget {...mod} />
      case "LessonVideoModule":
        return <VideoWidget {...mod} />
      case "LessonImageModule":
        return <ImageWidget {...mod} />
      case "LessonTriggerModule":
        return <TriggerWidget {...mod} />
      case "LessonDownloadFileModule":
        return <DownloadFileWidget {...mod} />
      case "LessonFillInTheBlankModule":
        return <FillInTheBlankWidget {...mod} />
    }
  }
  return (
    <div className="TeacherReaderWidgets">
      {props.lesson_modules && props.lesson_modules.map((mod, idx) => {
        if (isModuleImplemented(mod.lesson_module_name)) {
          return (
            <div key={idx} className="TeacherReaderWidgetContainer">
              {renderWidget(mod)}
            </div>
          )
        }
      })}
    </div>
  )
}

export { TeacherReaderWidgets };
